
import Vue from "vue";
import { Component } from "vue-property-decorator";
import { getContactPhoneNumber } from "@/app/utils/EnvConfig";

@Component
export default class LoginVerifyPhone extends Vue {

    private get content(): string {
        return this.$localize("login.verified.mobile.not.found.message", getContactPhoneNumber());
    }
}
